import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { toast } from "sonner";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (isAxiosError(error) && error.response) {
          const status = error.response.status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (isAxiosError(error) && error.response?.status === 401) {
        // Auth interceptor handles 401 — don't toast
        return;
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (isAxiosError(error)) {
        const status = error.response?.status;

        if (status === 401) return; // Handled by interceptor
        if (status === 403) {
          toast.error("You don't have permission to perform this action.");
          return;
        }
        if (status === 409) {
          toast.error("This record was modified. Please refresh and try again.");
          return;
        }
        if (status === 422) return; // Validation — handled by forms
        if (status === 429) {
          toast.error("Too many requests. Please wait a moment.");
          return;
        }
        if (status && status >= 500) {
          toast.error("Server error. Please try again later.");
          return;
        }
      }
      toast.error("An unexpected error occurred.");
    },
  }),
});
